export default __webpack_public_path__ + "static/media/piggybank.5f11287c.svg";